<template>
  <section
    v-if="props.data"
    class="customers"
    :class="[ props.data.parentClasses, props.data.parentStyle ? props.data.parentStyle : 'defaultStyle' ]"
  >
    <div class="container col">
      <div class="row">
        <div class="review-block col s12 m7">
          <strong
            v-if="props.data.label"
            class="label primary-color-text text-base-1"
          >{{ props.data.label }}</strong>

          <h2
            v-if="props.data.title"
            class="font-semibold text-[20px] mb-4"
          >
            {{ props.data.title }}
          </h2>

          <LazyHelpersReviewsCustomers
            module="catalog"
            :limit="3"
          />
        </div>
        <div class="col s12 m5">
          <div class="ourClients">
            <strong class="h3 center grey-text text-lighten-1">{{ props.data.titleSecond }}</strong>

            <LazyHelpersOurClientsIcons
              :clients-show-only="props.data.clients ? props.data.clients : []"
              :is-review="true"
              :random-count="props.data.randomCount"
              :dynamics="props.data.dynamics"
            />

            <LazyHelpersReviews />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})
</script>

<style lang="scss" scoped>
.customers {
  .ourClients {
    &:deep(.ourClientsIcons) {
      padding-top: 1rem;
    }
    &:deep(.ourClientsIcons__item) {
      min-width: calc(100% / 3);
      max-width: 33%;
      @media only screen and (min-width: 601px) {
        min-width: calc(100% / 2);
        max-width: 50%;
      }
      @media only screen and (min-width: 993px) {
        min-width: calc(100% / 3);
        max-width: 33%;
      }
    }
  }

  &:deep(.reviewsBlock) {
    display: flex;
    flex-wrap: wrap;
    padding-top: 1rem;
  }

  &:deep(.reviewsCustomersBlock__items) {
    padding: 0 0;
  }
}
</style>
